module.exports = __webpack_public_path__ + "img/lgads.ee7a80da.png";